import React, { useEffect, useState, Fragment } from 'react';
import { Clock } from 'lucide-react';
function getSecondsUntilMidnight() {
  // The offer counts down to 00:00 (midnight) of the current day —
  // i.e. the time remaining until the next midnight.
  const now = new Date();
  const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
  return Math.max(0, Math.floor((nextMidnight.getTime() - now.getTime()) / 1000));
}
function pad(n: number) {
  return String(n).padStart(2, '0');
}
export function CountdownTimer() {
  const [secondsLeft, setSecondsLeft] = useState<number>(() => getSecondsUntilMidnight());
  useEffect(() => {
    const interval = setInterval(() => {
      // Recompute from the real clock each tick so it stays anchored to
      // midnight and automatically rolls over when a new day begins.
      setSecondsLeft(getSecondsUntilMidnight());
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  const units = [{
    value: pad(hours),
    label: 'HORAS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEG'
  }];
  return <div className="bg-red-600 rounded-2xl px-4 py-3 w-full" data-id="element-11">
      <div className="flex items-center justify-center gap-2 text-white font-bold tracking-wide text-xs sm:text-sm mb-2" data-id="element-12">
        <Clock className="w-3.5 h-3.5" data-id="element-13" />
        LA OFERTA TERMINA EN:
      </div>
      <div className="flex items-center justify-center gap-1.5" data-id="element-14">
        {units.map((unit, i) => <Fragment key={unit.label} data-id="element-15">
            <div className="flex flex-col items-center" data-id="element-16">
              <div className="bg-red-800/60 rounded-lg px-2.5 py-1.5 min-w-[50px]" data-id="element-17">
                <span className="text-2xl sm:text-3xl font-extrabold text-white tabular-nums" data-id="element-18">
                  {unit.value}
                </span>
              </div>
              <span className="text-[9px] font-semibold text-red-100 mt-1 tracking-wider" data-id="element-19">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="text-xl sm:text-2xl font-extrabold text-white pb-4" data-id="element-20">
                :
              </span>}
          </Fragment>)}
      </div>
    </div>;
}